import { render, staticRenderFns } from "./NewBroadcastMessage.vue?vue&type=template&id=76c68ce4&scoped=true&"
import script from "./NewBroadcastMessage.vue?vue&type=script&lang=js&"
export * from "./NewBroadcastMessage.vue?vue&type=script&lang=js&"
import style0 from "./NewBroadcastMessage.vue?vue&type=style&index=0&id=76c68ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c68ce4",
  null
  
)

export default component.exports